import { useTranslation } from "react-i18next";
import type { PDSessionStatus } from "../types";

const STATUS_KEYS: Record<string, string> = {
  in_progress: "statusInProgress",
  scheduled: "statusReady",
  ended: "statusEnded",
};

export function SessionStatusBar({ status }: { status: PDSessionStatus }) {
  const { t } = useTranslation();
  const live = status === "in_progress";
  return (
    <div className="flex items-center justify-between rounded-xl bg-app-field p-3 shadow-raised">
      <div className="flex items-center gap-2 ps-1">
        <span className="relative flex h-3 w-3">
          {live && (
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-success opacity-75" />
          )}
          <span
            className={`relative inline-flex h-3 w-3 rounded-full ${live ? "bg-success" : "bg-app-icon"}`}
          />
        </span>
        <span className="text-sm font-semibold tracking-wide text-app-ink">
          {t("sessionStatus", { status: t(STATUS_KEYS[status] || "statusReady") })}
        </span>
      </div>
    </div>
  );
}
